// TODO: The logic needs to be finalised yet
export const currencyRenderer = (
  amount: number,
  currencyCode = 'USD',
): string => {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
    notation: `${
      Math.abs(amount).toString().length > 5 ? 'compact' : 'standard'
    }`,
    maximumSignificantDigits: 5,
    maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    // trailingZeroDisplay: 'stripIfInteger', // currently this option is experimental and not supported in TS
    // roundingMode: 'halfCeil',
  }).format(amount);
};
